/**
 * Holder for active context so apiService (non-React) can send X-Active-Context headers.
 * Updated by ActiveContextProvider when context changes.
 */
export type ActiveContextType = "ORGANIZATION" | "CLIENT_COMPANY";

export interface ActiveContextForApi {
  type: ActiveContextType;
  organizationId: number | null;
  clientCompanyId: number | null;
  adminOrganizationId?: number | null;
}

let current: ActiveContextForApi | null = null;

export function setActiveContextForApi(ctx: ActiveContextForApi | null): void {
  current = ctx;
}

export function getActiveContextForApi(): ActiveContextForApi | null {
  return current;
}
